var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
    fill: "#00AC54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.63997H16.7994C16.2755 5.63997 15.8493 5.21983 15.8493 4.70041L15.8423 1.0022",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4024 17.3925H7.09717V9.32202H17.4024V17.3925ZM7.79583 16.7H16.7037V10.0146H7.79583V16.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98967 9.66846H9.29102V17.0464H9.98967V9.66846Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0533 14.5925H7.44678V15.2851H17.0533V14.5925Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0533 11.73H7.44678V12.4225H17.0533V11.73Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.a2d65ad5759bb620b4c27772c7a138c1.svg";
export { ForwardRef as ReactComponent };